import React, {useEffect, useState} from 'react'
import axios from "axios";
import { useParams } from 'react-router-dom'
export const EMandatePrompt = () => {

    const { loanId } = useParams()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const authToken = urlParams.get('auth')
    const apiUrl = process.env.REACT_APP_API_URL;

    const [eMandateData, setEMandateData] = useState(undefined)
    const [configData, setConfigData] = useState(undefined)
    const [hostUrl, setHostUrl] = useState(undefined)

    useEffect(()=>{
        if(configData !== undefined){
            eNachRegAuditRequest()
        }
    }, [configData])

    useEffect(()=>{
        const hostname = window.location.origin;
        setHostUrl(hostname)
    }, [hostUrl])


    const getEMandateData = () => {
        let config = {
            method: 'get',
            url: `${apiUrl}/getenachdata?loan_id=${loanId}`,
            headers: {
                "X-AUTH": authToken
            }
        };
        axios(config).then((res) => {
            const resData = res.data.data
            if (res.data.success === true) {
                setEMandateData(resData)
            } else {
                console.log("Error")
            }
        }).catch(e => {
            console.log(e)
        })
    }

    const eNachRegAuditRequest = () => {

        let configDataReq = JSON.stringify(configData)
            let configRes = {
                method: 'put',
                url: `${apiUrl}/enachregistrationaudit`,
                headers: {
                    "X-AUTH": authToken,
                    "Content-Type": "application/json"
                },
                data: {
                    type: 'request',
                    transaction_id: configData.consumerData.txnId,
                    request: configDataReq
                }
            };

            axios(configRes)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                })
                .catch((error) => {
                    console.log(error);
                });
    }

    const handleResponse = (res) => {
        if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0300') {
            // success block
        } else if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0398') {
            // initiated block
        } else {
            // error block
        }
    }

    useEffect(()=>{
        console.log('emandate data is loaded')
    }, [eMandateData])

    useEffect(() => {
        getEMandateData();
    }, [])

    useEffect(() => {
        if (eMandateData) {
            const configJson = {
                'tarCall': false,
                'features': {
                    'showPGResponseMsg': true,
                    'enableAbortResponse': true,
                    'enableNewWindowFlow': false,
                    'enableExpressPay': true,
                    'siDetailsAtMerchantEnd': true,
                    'enableSI': true
                },
                'consumerData': {
                    'deviceId': 'WEBSH1',
                    'token': eMandateData.token,
                    'returnUrl': `${hostUrl}/redirect?transaction_id=${eMandateData.txnId}&auth=${authToken}`,
                    'responseHandler': handleResponse,
                    'paymentMode': 'netBanking',
                    'merchantLogoUrl': 'https://revfincapital.com/static/media/logo.11179b29.png',
                    'merchantId': eMandateData.merchantId,
                    'currency': eMandateData.currency,
                    'consumerId': eMandateData.consumerId,
                    'consumerMobileNo': eMandateData.consumerMobileNo,
                    'consumerEmailId': eMandateData.consumerEmailId,
                    'txnId': eMandateData.txnId,
                    'items': eMandateData.items,
                    'customStyle': {
                        'PRIMARY_COLOR_CODE': '#2E3470',
                        'SECONDARY_COLOR_CODE': '#FFFFFF',
                        'BUTTON_COLOR_CODE_1': '#FF6600',
                        'BUTTON_COLOR_CODE_2': '#FFFFFF'
                    },
                    'accountNo': eMandateData.accountNo,
                    'accountHolderName': eMandateData.accountHolderName,
                    'ifscCode': eMandateData.ifscCode,
                    'accountType': eMandateData.accountType,
                    'debitStartDate': eMandateData.debitStartDate,
                    'debitEndDate': eMandateData.debitEndDate,
                    'maxAmount': eMandateData.maxAmount,
                    'amountType': eMandateData.amountType,
                    'frequency': eMandateData.frequency
                }
            }
            setConfigData(configJson)
            window.$checkout.pnCheckout(configJson)
        }
    }, [eMandateData])

    return (
        <></>
    )
}